export default "__VITE_ASSET__edacbd50__"